/**
 * Labstep
 *
 * @module components/AccessKey/Action/Delete
 * @desc Action to delete an accessKey
 */

import { EntityActionDelete as DeleteAction } from 'labstep-web/components/Entity/Action/Delete';
import { AccessKey } from 'labstep-web/models/access-key.model';
import type React from 'react';
import type { AccessKeyActionDeleteProps } from './types';

export const AccessKeyActionDelete: React.FC<
  AccessKeyActionDeleteProps
> = ({ accessKeyItem }) => (
  <DeleteAction
    header={`Remove ${AccessKey.getHumanReadableEntityName()}`}
    confirmButtonContent="Remove"
    confirmMessage={`Are you sure you want to remove this ${AccessKey.getHumanReadableEntityName()}?`}
    entity={accessKeyItem}
    isRemoveAction
  />
);
